/**
 * Whether the `/` route should render the business DashboardPage (vs the legacy
 * HomePage). The dashboard is for the smb/full deployment profiles; enterprise
 * profiles keep Home. Guarded on `isLoaded` so we don't flash Home → Dashboard
 * before the feature manifest resolves.
 */
export function shouldShowDashboard(profile: string, isLoaded: boolean): boolean {
  return isLoaded && (profile === 'smb' || profile === 'full')
}

export type HomeSurface = 'widgets' | 'dashboard' | 'legacy'

/**
 * What `/` renders (Home spec 2026-09-23 D1): the widget page when the LOADED
 * manifest holds `home_dashboard`; else the profile rule above; else the
 * legacy Home. The not-loaded guard is the same one `shouldShowDashboard`
 * keeps, so nothing flashes before the manifest resolves.
 */
export function homeSurface(profile: string, features: ReadonlySet<string>, isLoaded: boolean): HomeSurface {
  if (!isLoaded) return 'legacy'
  if (features.has('home_dashboard')) return 'widgets'
  return shouldShowDashboard(profile, isLoaded) ? 'dashboard' : 'legacy'
}
